import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss']
})
export class ColorPickerComponent {

  @Input() color: string;
  @Input() changeDelay: number;
  @Input() showClear: boolean = false;
  @Input() disabled: boolean = false;

  @Output() colorChange: EventEmitter<string>;

  timeout: any;

  constructor() {
    this.colorChange = new EventEmitter<string>();
  }

  onColorChange(): void {
    if (this.changeDelay) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.colorChange.emit(this.color), this.changeDelay);
    } else {
      this.colorChange.emit(this.color);
    }
  }

}
